export interface MultilanguageContentItem {
  lang_code: string;
  content: string;
}

/** API request/response: array of { lang_code, content } (plain text per language). */
export type MultilanguageContent = MultilanguageContentItem[];

export enum MessageTemplateType {
  Initial = 0,
  Quick = 1,
  Inactivity = 2
}

export interface ChatMessageTemplate {
  id: number;                      // Min row ID in the group (use for get/update/delete); API accepts any row ID in group
  group_id?: string | null;        // Optional UUID grouping rows (one row per language); used to group accordions
  content: MultilanguageContent;   // Array of { lang_code, content } (plain text per language)
  type: MessageTemplateType;
  category?: string | null;         // Category name (max 250 chars)
  keyword?: string[] | null;       // Array of keyword strings
  order: number;                   // Order for display (used for sorting)
  /** Inactivity templates only; milliseconds until message is sent. */
  delay?: number | null;
  createdDate: string;             // ISO date string
  updatedDate: string;             // ISO date string
  deletedDate?: string | null;     // ISO date string (null if not deleted)
}

export interface ChatMessageTemplateCreateRequest {
  content: MultilanguageContent;  // Required: non-empty array of { lang_code, content }
  type: MessageTemplateType;
  category?: string | null;       // Optional, max 250 characters
  keyword?: string[] | null;      // Optional, array of keyword strings
  order?: number;                 // Optional, defaults to 0
  delay?: number | null;
}

export interface ChatMessageTemplateUpdateRequest {
  content?: MultilanguageContent;  // Optional: array of { lang_code, content }
  type?: MessageTemplateType;
  category?: string | null;         // Optional, max 250 characters
  keyword?: string[] | null;       // Optional, array of keyword strings
  order?: number;                   // Optional
  delay?: number | null;
}

export interface ChatMessageTemplateOrderUpdateRequest {
  id: number;
  order: number;
}

export type ChatMessageTemplateOrderBulkUpdateRequest = ChatMessageTemplateOrderUpdateRequest[];

